<template>
    <div class="e-tags tw:flex tw:items-center tw:justify-start" :class="[isAttached ? 'tw:gap-0 e-taglist-attached' : 'tw:gap-2 tw:flex-wrap']" v-bind="nonTaglistAttrs">
        <slot />
    </div>
</template>

<script>
/**
 * ETaglist - Implementation of a PrimeVue taglist to replicate Buefy's b-taglist
 *
 * Basic Usage:
 *   <e-taglist>
 *     <e-tag>Tag 1</e-tag>
 *     <e-tag>Tag 2</e-tag>
 *     <e-tag>Tag 3</e-tag>
 *   </e-taglist>
 *
 * Attached Tags:
 *   <e-taglist attached>
 *     <e-tag type="is-dark">Label</e-tag>
 *     <e-tag type="is-primary">Value</e-tag>
 *   </e-taglist>
 */
export default {
    name: 'ETaglist',
    inheritAttrs: false,

    computed: {
        isAttached() {
            return Object.keys(this.$attrs).includes('attached');
        },

        nonTaglistAttrs() {
            const { attached, ...rest } = this.$attrs;

            return rest;
        },
    },
};
</script>

<style scoped>
.e-taglist-attached :deep(> *) {
    border-radius: 0;
}

.e-taglist-attached :deep(> *:first-child) {
    border-top-left-radius: 0.5rem;
    border-bottom-left-radius: 0.5rem;
}

.e-taglist-attached :deep(> *:last-child) {
    border-top-right-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
}
</style>
